'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PDFIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PDFIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.5 23.5C20.7652 23.5 21.0196 23.3946 21.2071 23.2071C21.3946 23.0196 21.5 22.7652 21.5 22.5V6.473C21.4995 4.88868 20.8697 3.36943 19.7493 2.24933C18.6288 1.12923 17.1093 0.5 15.525 0.5H3.5C3.23478 0.5 2.98043 0.605357 2.79289 0.792893C2.60536 0.98043 2.5 1.23478 2.5 1.5V22.5C2.5 22.7652 2.60536 23.0196 2.79289 23.2071C2.98043 23.3946 3.23478 23.5 3.5 23.5H20.5Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 0.579102V4.5001C16.5 4.76532 16.6054 5.01967 16.7929 5.20721C16.9804 5.39474 17.2348 5.5001 17.5 5.5001H21.42"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.47852 15C8.47852 15.3978 8.32048 15.7794 8.03918 16.0607C7.75787 16.342 7.37634 16.5 6.97852 16.5H5.47852V13.5H6.97852C7.37634 13.5 7.75787 13.658 8.03918 13.9393C8.32048 14.2206 8.47852 14.6022 8.47852 15Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.47852 19.499V16.499"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4785 13.5C11.2742 13.5 12.0372 13.8161 12.5998 14.3787C13.1624 14.9413 13.4785 15.7044 13.4785 16.5C13.4785 17.2956 13.1624 18.0587 12.5998 18.6213C12.0372 19.1839 11.2742 19.5 10.4785 19.5V13.5Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4785 19.5V14.5C15.4785 14.2348 15.5839 13.9804 15.7714 13.7929C15.9589 13.6054 16.2133 13.5 16.4785 13.5H18.4785"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4785 16.499H17.4785"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

PDFIcon.propTypes = {
  sx: PropTypes.object
}
